import React from "react";
import BusinessEntityShowContent from "../shared/components/BusinessEntityShowContent";
import Background from "../../shared/components/ui/Background";
import sample2Logo from "./images/sample2_logo.jpeg";
import sample2Work1Image1 from "./images/sample2_work1_image1.jpeg";
import sample2Work2Image1 from "./images/sample2_work2_image1.jpeg";
import sample2Work2Image2 from "./images/sample2_work2_image2.jpeg";

const demoBusinessEntity = {
  code: "01JVV4RJYX2DRBCPKWTD017BCA",
  business_type: "個人事業主",
  use_case: "contractor",
  is_own: false,
  name: "エーループストラクチャーラボ",
  name_kana: "",
  branch_name: "",
  introduction:
    "福岡県を拠点とする建築構造設計です。2003年の設立以来、安全性・耐久性・経済性を兼ね備えた構造設計を提供し、建築の根幹を支える役割を担っています。私自身、建築構造設計の専門家として長年にわたり住宅・商業施設・公共施設・高層ビルなど、さまざまなプロジェクトに携わってきました。個人事業ならではの柔軟性を活かし、クライアントの要望に応じた最適な構造ソリューションを提供しています。\nまた、、最新の解析技術を活用し、地震・風荷重などの自然災害に強い設計を実施し、環境負荷の少ない材料選定や、施工効率を考慮した合理的な構造計画にも注力しています。",
  number_of_employees: 1,
  main_client: "A-Loop都市開発株式会社\nエーループ株式会社",
  postal_code: "5420062",
  address1: "大阪市中央区上本町西",
  address2: "1丁目1-5",
  address3: "エーループビル7階",
  establishment_year_month: "2003/4",
  capital_ten_thousand_yen: 0,
  president_name: "大河内 次郎",
  facebook_url: "https://www.facebook.com",
  instagram_url: "https://www.instagram.com",
  note_url: "https://note.com",
  pinterest_url: "https://www.pinterest.jp",
  threads_url: "https://www.threads.net",
  tiktok_url: "https://www.tiktok.com",
  x_url: "https://twitter.com",
  youtube_url: "https://www.youtube.com",
  website_url: "https://aloop.jp/",
  prefecture: { id: 27, name: "大阪府" },
  industry: { id: 2, name: "構造設計事務所" },
  logo_image_url: sample2Logo,
  used_architectural_software_categories: [
    {
      category: "2DCAD",
      softwares: [
        { id: 1, name: "AutoCAD" },
        { id: 2, name: "DRA-CAD" },
        { id: 3, name: "Jw_cad" },
        { id: 4, name: "その他" },
      ],
    },
    {
      category: "3DCAD・モデリング",
      softwares: [
        { id: 5, name: "3dsMAX" },
        { id: 6, name: "ARCHITREND ZERO" },
        { id: 7, name: "Blender" },
        { id: 8, name: "Cinema4D" },
        { id: 9, name: "Rhinoceros 3D" },
        { id: 10, name: "Shade3D" },
        { id: 11, name: "SketchUp" },
        { id: 12, name: "Twinmotion" },
        { id: 13, name: "Vectorworks" },
        { id: 14, name: "その他" },
      ],
    },
    {
      category: "BIM",
      softwares: [
        { id: 15, name: "Archicad" },
        { id: 16, name: "Autodesk Revit" },
        { id: 17, name: "GLOOBE" },
        { id: 18, name: "Tekla Structures" },
        { id: 19, name: "VectorWorks architect" },
        { id: 20, name: "その他" },
      ],
    },
    {
      category: "一貫構造計算",
      softwares: [
        { id: 21, name: "Super Build／SS7（SS3）" },
        { id: 22, name: "ASCAL" },
        { id: 23, name: "BUILD.一貫V（IV＋）" },
        { id: 24, name: "Building Editor" },
        { id: 25, name: "BUS-6、NBUS7" },
      ],
    },
    { category: "木造構造計算", softwares: [{ id: 26, name: "KIZUKURI" }] },
  ],
  client_info: null,
  contractor_info: {
    supported_business_service_note:
      "耐震設計と木造建築を中心とした建築構造設計を提供しています。\n\n耐震診断・補強設計（既存建物の耐震性評価と改修計画）\n木造建築の構造設計（伝統工法から最新技術まで幅広く対応）\nRC・S造の構造設計（住宅、商業施設、公共施設など）\n長寿命化設計（メンテナンスを考慮した耐久性の高い設計）\n木質ハイブリッド構造の設計（環境負荷の少ない持続可能な建築設計）\n構造監理業務（施工段階での構造的な品質管理）\n災害復旧・耐震改修設計（地震後の安全確保と補修設計）",
    desired_industries: [{ id: 2, name: "構造設計事務所" }],
    supported_business_fields: [{ id: 2, name: "構造設計" }],
    supported_building_types: [
      {
        id: 1,
        name: "個人住宅",
        structure_types: [
          { id: 1, name: "木造（W造）" },
          { id: 2, name: "中規模木造（W造）" },
          { id: 3, name: "軽量鉄骨造（S造）" },
        ],
      },
      {
        id: 2,
        name: "共同住宅",
        structure_types: [
          { id: 1, name: "木造（W造）" },
          { id: 2, name: "中規模木造（W造）" },
          { id: 3, name: "軽量鉄骨造（S造）" },
          { id: 4, name: "重量鉄骨造（S造）" },
          { id: 5, name: "鉄筋コンクリート造（RC造）" },
          { id: 6, name: "鉄骨鉄筋コンクリート造（SRC造）" },
          { id: 7, name: "気泡コンクリート（ALC造）" },
          { id: 8, name: "プレキャストコンクリート（PC造）" },
          { id: 9, name: "アルミ造（AL造）" },
          { id: 10, name: "コンクリート充填鋼管構造（CFT造）" },
          { id: 11, name: "コンクリートブロック造（CB造）" },
          { id: 12, name: "その他" },
        ],
      },
    ],
    supported_prefectures: [
      {
        region: "北海道・東北",
        prefectures: [
          { id: 1, name: "北海道" },
          { id: 2, name: "青森県" },
          { id: 3, name: "岩手県" },
          { id: 5, name: "秋田県" },
          { id: 4, name: "宮城県" },
          { id: 6, name: "山形県" },
          { id: 7, name: "福島県" },
        ],
      },
      {
        region: "関東・甲信越",
        prefectures: [
          { id: 13, name: "東京都" },
          { id: 14, name: "神奈川県" },
          { id: 11, name: "埼玉県" },
          { id: 12, name: "千葉県" },
          { id: 8, name: "茨城県" },
          { id: 9, name: "栃木県" },
          { id: 10, name: "群馬県" },
          { id: 16, name: "山梨県" },
          { id: 17, name: "長野県" },
        ],
      },
      {
        region: "北陸・中部",
        prefectures: [
          { id: 23, name: "愛知県" },
          { id: 21, name: "岐阜県" },
          { id: 22, name: "静岡県" },
          { id: 24, name: "三重県" },
          { id: 15, name: "新潟県" },
          { id: 19, name: "石川県" },
          { id: 18, name: "富山県" },
          { id: 20, name: "福井県" },
        ],
      },
      {
        region: "近畿",
        prefectures: [
          { id: 27, name: "大阪府" },
          { id: 28, name: "兵庫県" },
          { id: 26, name: "京都府" },
          { id: 25, name: "滋賀県" },
          { id: 29, name: "奈良県" },
          { id: 30, name: "和歌山県" },
        ],
      },
      {
        region: "中国・四国",
        prefectures: [
          { id: 33, name: "岡山県" },
          { id: 34, name: "広島県" },
          { id: 31, name: "鳥取県" },
          { id: 32, name: "島根県" },
          { id: 35, name: "山口県" },
          { id: 37, name: "香川県" },
          { id: 36, name: "徳島県" },
          { id: 38, name: "愛媛県" },
          { id: 39, name: "高知県" },
        ],
      },
      {
        region: "九州・沖縄",
        prefectures: [
          { id: 40, name: "福岡県" },
          { id: 41, name: "佐賀県" },
          { id: 42, name: "長崎県" },
          { id: 43, name: "熊本県" },
          { id: 44, name: "大分県" },
          { id: 45, name: "宮崎県" },
          { id: 46, name: "鹿児島県" },
          { id: 47, name: "沖縄県" },
        ],
      },
    ],
    architectural_design_works: [
      {
        project_name: "エーループ保育園",
        above_ground_floors: 2,
        underground_floors: null,
        total_floor_area: 1200,
        completion_year: 2023,
        project_detail:
          "保育園は、子どもたちの成長と創造性を育むことを目的に設計された保育施設です。建物全体に国産ヒノキを使用し、木の温もりに包まれた安心できる空間を実現しました。園内には自然光を最大限に取り入れる大きな窓を設置し、四季の変化を感じられる環境を提供。オープンプランの保育室は、可動式の仕切りによって多目的に使用可能で、子どもたちの活動に柔軟に対応できます。\nまた、安全面にも配慮し、耐震性に優れた木造構造を採用し、万が一の災害時にも避難しやすい設計となっています。園庭には、自然と触れ合うことができるビオトープを設け、子どもたちがのびのびと遊べる空間を確保。地域との交流を大切にするため、週末には親子イベントや地域向けワークショップの開催も可能な設計としました。",
        prefecture: { id: 40, name: "福岡県" },
        building_type: { id: 8, name: "学校・教育施設" },
        structure_types: [{ id: 1, name: "木造（W造）" }],
        images: [
          {
            url: sample2Work1Image1,
          },
        ],
      },
      {
        project_name: "A-Loopテラスハウス",
        above_ground_floors: 3,
        underground_floors: null,
        total_floor_area: 2500,
        completion_year: 2024,
        project_detail:
          "A-Loopテラスハウスは自然と共生するサステナブルなライフスタイルを提案する低層集合住宅です。木造建築ならではの温かみのあるデザインを採用し、各住戸のバルコニーやテラスを広く取ることで、居住者が四季折々の風景を楽しめるように設計しました。\n住宅の断熱性能を高めるため、高性能な木製サッシと自然素材の断熱材を使用し、省エネ性能を向上。屋根には太陽光発電パネルを設置し、エネルギーの自給率を高める工夫も施されています。共用スペースには、住民が交流できるコミュニティラウンジや、家庭菜園スペースを設け、住民同士のつながりを大切にする設計としました。\nさらに、もみじの木々を敷地内に植樹し、四季の移ろいを感じながら穏やかに暮らせる環境を提供。防災面では、耐震等級3の設計を採用し、万が一の災害時にも安心して暮らせる建物となっています。",
        prefecture: { id: 40, name: "福岡県" },
        building_type: { id: 2, name: "共同住宅" },
        structure_types: [
          { id: 5, name: "鉄筋コンクリート造（RC造）" },
          { id: 1, name: "木造（W造）" },
        ],
        images: [
          {
            url: sample2Work2Image1,
          },
          {
            url: sample2Work2Image2,
          },
        ],
      },
    ],
  },
};

const SamplesShow1 = () => {
  return (
    <Background color="brand.50">
      <BusinessEntityShowContent
        businessEntity={demoBusinessEntity}
        currentUser={undefined}
        preview={false}
        disableBackLink
      />
    </Background>
  );
};

export default SamplesShow1;
